<template>
    <div class="page">
        <div class="yjcc_box">
            <div style="font-size: 1.4vh;color: #67c23a;padding: 1vh;background-color: #f0f9eb;margin-bottom: 10px;">
                30秒内免费，超过30秒扣除1点，限制60秒，建议准确选择字幕位置，选太大会让视频画质下降
            </div>
            <div class="video_box">
                <div class="video_list">
                    <video ref="myvideo" class="video_sp" :src="videoUrl" @loadedmetadata="onLoadedMetadata"
                        @ended="onEnded" @pause="onPause" @play="onPlay" @timeupdate="onTimeUpdateEvent"
                        :controls="false" :enableProgressGesture="false" id="myVideo" objectFit="cover"
                        :showCenterPlayBtn="false" :showFullscreenBtn="false" :showPlayBtn="false"
                        :style="{ width: videoWidth + 'px', height: videoHeight + 'px' }" @error="videoErrorCallback"
                        playsinline webkit-playsinline>
                        <!-- <source :src="video" type="video/mp4" > -->
                    </video>
                    <div class="move_box">
                        <!-- <div class="movable-area">
                            <div class="border_title" v-for="(box, index) in selectBoxList" :key="index"
                            :style="{ width: box.w + 'px', height: box.h + 'px', 'z-index': [box.id === currentBoxId ? 5 : 4] }"
                                @touchstart="onTouchStart(index, $event)" @touchmove="onTouchMove(index, $event)"
                                @touchend="onTouchEnd(index, $event)">
                                <span>可移动缩放的框 {{ index + 1 }}</span>
                            </div>
                        </div> -->
                        <div class="movable-area">
                            <div @touchstart.prevent="editSelectBox_new(box.id, $event)"
                                @touchend.prevent="selectBoxHandleEnd" @touchmove.prevent="onChange"
                                @mousedown.prevent="editSelectBox_new(box.id, $event)"
                                @mouseup.prevent="selectBoxHandleEnd" @mousemove.prevent="onChange" class="border_title"
                                :style="{ width: box.w + 'px', height: box.h + 'px', 'z-index': [box.id === currentBoxId ? 5 : 4], transform: `translate(${box.x}px, ${box.y}px)` }"
                                :id="box.id" v-for="(box, index) in selectBoxList" :key="index">
                                <!-- <div class="btn_white" v-if="box.id === currentBoxId">
                                    <div>2</div>
                                </div> -->
                                <!-- <div @touchstart.stop="delSelectBox(box.id)" class="btn_del"
                                    v-if="box.id === currentBoxId">
                                    <i class="el-icon-close"></i>
                                </div> -->
                                <!-- <div class="btn_fixed" v-if="box.id === currentBoxId">
                                    <div>1</div>
                                </div> -->
                                <div @touchend.stop="handleEnd" @touchmove.stop="handleMove"
                                    @touchstart.stop="handleStart" @mousedown.stop="handleStart"
                                    @mousemove.stop="handleMove" @mouseup.stop="handleEnd" class="btn_move" :id="box.id"
                                    v-if="box.id === currentBoxId" :style="{ 'background-color': box.color }">
                                    <i class="el-icon-d-caret"></i>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="task_footer">
                <div class="center_box" v-if="videoWidth > 0">
                    <div style="font-size: 1.4vh;">{{ formatSeconds(videoInfo.progress) + ' / ' +
                        formatSeconds(videoInfo.duration) }}</div>
                    <div class="btn_bf" style="font-size: 25px;">
                        <i class="el-icon-video-play" v-if="!videoLinkIsPlay" @click="play"></i>
                        <i class="el-icon-video-pause" v-else @click="pause"></i>
                        <!-- <u-icon name="play-right-fill" v-if="!videoLinkIsPlay" color="#fff" size="26"
                            @click="play"></u-icon>
                        <u-icon v-else name="pause" color="#fff" size="26" @click="pause"></u-icon> -->
                    </div>
                    <div></div>
                </div>
                <div style="padding: 0 20px;">
                    <el-slider activeColor="#7476ff" @input="sliderChanging" class="hdq_line" v-if="videoWidth > 0"
                        :max="videoInfo.duration" :min="0" :step="1" :show-tooltip="false"
                        :value="videoInfo.progress"></el-slider>
                </div>
                <div class="bottom_box">

                    <div class="user_Button" style="padding: 0px 4vh;">
                        <!-- <button @click="addSelectBox" class="btn_xt" hoverClass="none" type="warn">添加选区</button> -->
                        <button @click="submitCut" hoverClass="none" type="warn"
                            style="color: #fff;font-weight: 600;width: 100%;font-size: 1.5vh;height: 4vh;">开始去字幕</button>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
export default {
    name: 'qzm',
    components: {

    },
    // 定义属性
    data() {
        return {
            yd_items: [
                { left: 50, top: 50, width: 100, height: 100 },
                { left: 200, top: 150, width: 150, height: 150 }
            ],

            scale: 1,
            videoUrl: "",
            originalUrl: "",
            videoTitle: "",
            videoInfo: {
                duration: 0,
                progress: 0,
                fpsWidth: 0,
                fpsHeight: 0,
                fpsRatio: 0
            },
            minSelectBox: {
                width: 30,
                height: 30
            },
            maxSelectBox: { // 新增 maxSelectBox
                width: 999, // 设置最大宽度
                height: 200 // 设置最大高度
            },
            selectBoxList: [],
            currentBoxId: 0,
            colorList: ["#0c8ff3", "#F3A077", "#F6BF79", "#F377CF", "#D477F3"],
            videoContext: null,
            videoLinkIsPlay: !1,
            windowWidth: 414,
            windowHeight: 414,
            videoWidth: 0,
            videoHeight: 0,
            sliderMargin: 24,
            sliderWidth: 0,
            videoRect: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: 0,
                height: 0
            },
            timeRect: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: 0,
                height: 0
            },
            dpr: 3,
            isTounchMove: false,
            isSelectBoxTounchMove: !1,
            isTimeLeftTounchMove: !1,
            isTimeRightTounchMove: !1,
            startPoint: {
                x: 0,
                y: 0
            },
            upitem: [],
            upok: false,
            startX: 0,
            startY: 0,
            lastX: 0,
            lastY: 0,
            isDragging: false,
            isDragging2: false,
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        handleStart(t) {
            console.log(t, 'ccc')
            if (!this.isTounchMove) {
                var e = t.changedTouches ? t.changedTouches[0] : t;
                this.startPoint.x = e.clientX + 20, this.startPoint.y = e.clientY + 20;
                this.isDragging2 = true
                if (!t.changedTouches) {
                    document.addEventListener('mousemove', this.handleMove);
                    document.addEventListener('mouseup', this.handleEnd);
                }
            }
        },
        handleMove(t) {
            if (this.isDragging2 == false) return;
            t.preventDefault()
            this.isTounchMove = true
            console.log(t, "ev");
            var e = t.changedTouches ? t.changedTouches[0] : t,
                i = 0;
            if (-1 !== i) {
                if (console.log(i, "handleMove-index"), e.clientX <= this.videoRect.right) {
                    var o = e.clientX - this.videoRect.left - this.selectBoxList[i].old.x;
                    this.minSelectBox.width > o && (o = this.minSelectBox.width);
                    var n = o > this.videoRect.width ? this.videoRect.width : o;
                    n += 6;
                    console.log(n, "handleMove-w"), -1 != i && (this.selectBoxList[i].w = n);
                }
                if (e.clientY <= this.videoRect.bottom) {
                    var s = e.clientY - this.videoRect.top - this.selectBoxList[i].old.y;
                    this.minSelectBox.height > s && (s = this.minSelectBox.height);
                    this.maxSelectBox.height < s && (s = this.maxSelectBox.height);
                    var d = s > this.videoRect.height ? this.videoRect.height : s;
                    d += 6;
                    console.log(d, "handleMove-h"), -1 != i && (this.selectBoxList[i].h = d);
                }
                console.log(this.selectBoxList, "handleMove-this.selectBoxList");
            }
        },
        handleEnd(t) {
            console.log('框end', t)
            this.isDragging2 = false
            this.isTounchMove && (this.isTounchMove = false);
            if (t.type === 'mouseup') {
                document.removeEventListener('mousemove', this.handleMove);
                document.removeEventListener('mouseup', this.handleEnd);
            }
        },

        editSelectBox_new(t, event) {
            this.isDragging = true;
            const clientX = event.touches ? event.touches[0].clientX : event.clientX;
            const clientY = event.touches ? event.touches[0].clientY : event.clientY;
            this.syncBoxXY();
            var e = this.selectBoxList.findIndex(function (e) {
                return e.id === t;
            }); -1 != e && (this.currentBoxId = this.selectBoxList[e].id);
            // const touch = event.touches[0];
            this.startX = clientX;
            this.startY = clientY;
            this.lastX = this.selectBoxList[e].x;
            this.lastY = this.selectBoxList[e].y;
            if (!event.touches) {
                document.addEventListener('mousemove', this.onChange);
                document.addEventListener('mouseup', this.selectBoxHandleEnd);
            }
        },
        syncBoxXY() {
            this.selectBoxList.forEach(function (t, e, i) {
                i[e].x = t.old.x, i[e].y = t.old.y, i[e].timeX = t.oldTime.x, i[e].timeY = t.oldTime.y;
            });
        },
        onChange(t) {
            if (this.isDragging == false) return;
            this.isSelectBoxTounchMove = !0
            console.log(t, "onChange-e")
            console.log(this.selectBoxList,
                "onChange-this.selectBoxList1");

            // var e = this.selectBoxList.findIndex(function (e) {
            //     return e.id === Number(t.currentTarget.id);
            // });
            var e = 0
            // const touch = t.touches[0];
            // 获取坐标（兼容触摸和鼠标）
            const touch = t.touches ? t.touches[0] : t;
            const deltaX = touch.pageX - this.startX;
            const deltaY = touch.pageY - this.startY;
            var x = this.lastX + deltaX <= 0 ? 0 : this.lastX + deltaX
            var y = this.lastY + deltaY <= 0 ? 0 : this.lastY + deltaY
            x = x + this.selectBoxList[e].w >= this.videoWidth ? x - this.selectBoxList[e].w - (x - this.videoWidth) : x
            y = y + this.selectBoxList[e].h >= this.videoHeight ? y - this.selectBoxList[e].h - (y - this.videoHeight) : y
            this.selectBoxList[e].x = x;
            this.selectBoxList[e].y = y;
            this.selectBoxList[e].old.x = this.selectBoxList[e].x
            this.selectBoxList[e].old.y = this.selectBoxList[e].y
            console.log(this.selectBoxList, "onChange-this.selectBoxList2");
            console.log(this.selectBoxList[e].x * this.videoInfo.fpsRatio, this.selectBoxList[e].y * this.videoInfo.fpsRatio)
            console.log(this.selectBoxList[e].x + this.selectBoxList[e].w, this.selectBoxList[e].y + this.selectBoxList[e].h)
            console.log(this.videoWidth, this.videoHeight)
        },

        delSelectBox(t) {
            console.log(t, "delSelectBox-t");
            this.syncBoxXY();
            var e = this.selectBoxList.findIndex(function (e) {
                return e.id === t;
            }); -
                1 != e && (this.selectBoxList.splice(e, 1), this.currentBoxId === t && (this.currentBoxId = 0)),
                0 == this.selectBoxList.length ? this.currentBoxId = 0 : this.currentBoxId = this.selectBoxList[0]
                    .id;
        },

        selectBoxHandleEnd(t) {
            if (t.type === 'mouseup') {
                document.removeEventListener('mousemove', this.onChange);
                document.removeEventListener('mouseup', this.selectBoxHandleEnd);
            }
            this.isDragging = false;

            this.isSelectBoxTounchMove && (console.log(t, "selectBoxHandleEnd-ev"), this.isSelectBoxTounchMove = !
                1);

        },
        addSelectBox() {
            var xuanqu = this.getMaxSelectBoxNum()
            // this.$msg.error("最多只能添加" + xuanqu + "个区域"), 
            if (this.syncBoxXY(), this.selectBoxList.length >= xuanqu) console.log("最多只能添加" + xuanqu + "个区域");
            else if (0 != this.videoInfo.duration) {
                console.log(this.timeRect, "timeRect");
                var e = this.videoInfo.progress / this.videoInfo.duration * this.sliderWidth,
                    i = .2 * this.sliderWidth;
                e + i > this.sliderWidth && (i = this.sliderWidth - e);
                var o = this.videoInfo.progress,
                    n = this.videoInfo.duration / this.sliderWidth * i + o;
                n > this.videoInfo.duration && (n = this.videoInfo.duration);
                var s = this.colorList.length >= this.selectBoxList.length ? this.colorList[this.selectBoxList
                    .length] : this.colorList[0],
                    d = {
                        id: new Date().getTime(),
                        startTime: o,
                        endTime: n,
                        x: this.videoWidth * 0.1,
                        y: this.videoHeight * 0.5,
                        w: this.videoWidth * 0.6,
                        h: this.videoHeight * 0.1,
                        old: {
                            x: this.videoWidth * 0.1,
                            y: this.videoHeight * 0.5,
                        },
                        color: s,
                        timeX: e,
                        timeY: 0,
                        timeW: i,
                        timeH: 26,
                        oldTime: {
                            x: e,
                            y: 0,
                            w: i,
                            h: 26
                        }
                    };
                this.selectBoxList.push(d)
                this.currentBoxId = d.id
                // this.videoInfo.progress = n 
                // this.videoContext.seek(n / 1e3);
            } else console.log("视频时长为0或者尚未视频加载完成");
        },
        getMaxSelectBoxNum() {
            const boxnum = Number(this.$route.query.boxnum)
            return Number.isInteger(boxnum) && boxnum >= 1 ? Math.min(boxnum, 3) : 1
        },
        submitCut() {
            if (0 !== this.selectBoxList.length) {
                this.syncBoxXY();
                const fpsRatio = this.videoInfo.fpsRatio;
                console.log(fpsRatio, "submitCut-ratio");

                const configs = this.selectBoxList.map(box => ({
                    x: Math.round(box.x * fpsRatio),
                    y: Math.round(box.y * fpsRatio),
                    h: Math.round(box.h * fpsRatio),
                    w: Math.round(box.w * fpsRatio),
                    startTime: (box.startTime / 1000).toFixed(3),
                    endTime: (box.endTime / 1000).toFixed(3),
                    org_width: this.videoInfo.fpsWidth,
                    org_height: this.videoInfo.fpsHeight
                }));

                const extra = JSON.stringify({
                    configs: configs,
                    taskType: 1,
                    url: this.originalUrl
                });

                const data = {
                    mode: "watermark_video",
                    url: this.originalUrl,
                    // rmType: this.upitem.ms,
                    // upType: this.upitem.type,
                    extra: extra
                };

                console.log(data, "submitCut-data");
                this.ks(data)

                // var n = this;
                // t.$u.api.MyTool.fethSubmitCutV4(o).then(function(e) {
                // 	console.log(e, "fethSubmitRemoveCaptions - res"), n.videoCutCacula(e), t.hideLoading(),
                // 		n.submitAfter();
                // }).catch(function(e) {
                // 	t.hideLoading(), console.log(e), e.statusCode && 200001 === e.statusCode && n.$refs[
                // 		"limit"].openfrequency();
                // });
            } else this.$message.error("请先添加选区");
        },
        ks(data) {
            data['xgcs'] = 1
            data['other'] = data.extra
            data['type'] = 'qzm'

            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/videotask/maketask', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    // console.log(index)
                    // this.$msg.success(res.data.msg)
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        customClass: 'newdialog',
                        callback: action => {
                            this.$emit('showstatus', 'Hello from Child!')
                        }
                    });
                    // this.$refs.Balance.get_user()
                } else {
                    this.$msg.error(res.data.msg)
                }
            }).finally(() => {
                this.uploading = false
                loading.close();
            })
        },
        // onLoadedMetadata() {
        //     const video = this.$refs.myvideo;
        //     this.videoContext = video;
        //     const componentInstance = this;

        //     console.log(`Video width: ${video.videoWidth}, height: ${video.videoHeight}, duration: ${video.duration}s`);

        //     // 设置视频信息
        //     this.videoInfo.duration = video.duration * 1000; // 将秒转换为毫秒
        //     this.videoInfo.fpsWidth = video.videoWidth;
        //     this.videoInfo.fpsHeight = video.videoHeight;

        //     // 初始视频宽度和高度
        //     let videoWidth = 200;
        //     let videoHeight = 200;

        //     console.log(this.videoInfo, "onLoadedMetadata - 视频加载完成");

        //     this.$nextTick(() => {
        //         const videoBoxRect = document.querySelector(".video_box").getBoundingClientRect();
        //         console.log(videoBoxRect, "initVideoBoxRect - 视频容器尺寸");

        //         // 计算视频的宽高比和容器的宽高比
        //         const videoAspectRatio = video.videoWidth / video.videoHeight;
        //         const containerWidth = videoBoxRect.width; // 减去左右各20px的边距
        //         const containerHeight = videoBoxRect.height;
        //         const containerAspectRatio = containerWidth / containerHeight;

        //         // 根据容器的宽高比调整视频的宽度和高度
        //         if (videoAspectRatio > containerAspectRatio) {
        //             videoWidth = containerWidth;
        //             videoHeight = containerWidth / videoAspectRatio;
        //         } else {
        //             videoHeight = containerHeight;
        //             videoWidth = containerHeight * videoAspectRatio;
        //         }

        //         // 设置视频的 fps 比率
        //         this.videoInfo.fpsRatio = this.videoInfo.fpsWidth / videoWidth;

        //         console.log(videoHeight, "this.videoHeight");
        //         console.log(videoWidth, "this.videoWidth");

        //         this.videoWidth = videoWidth;
        //         this.videoHeight = videoHeight;

        //         this.$nextTick(() => {
        //             componentInstance.initVideoRect();
        //             componentInstance.initTimeRect();
        //         });
        //     });
        // },
        onLoadedMetadata() {
            const video = this.$refs.myvideo;
            this.videoContext = video
            var i = this;

            console.log(`Video width: ${video.videoWidth}, height: ${video.videoHeight}, duration: ${video.duration}s`);
            var n = video.duration,
                s = video.videoWidth,
                d = video.videoHeight;
            this.videoInfo.duration = 1e3 * n
            this.videoInfo.fpsWidth = s
            this.videoInfo.fpsHeight = d
            this.videoWidth = 200
            this.videoHeight = 200
            console.log(this.videoInfo, "onLoadedMetadata-e 视频加载完成");
            this.$nextTick(() => {
                const e = document.querySelector(".video_box").getBoundingClientRect();
                console.log(e, "initVideoBoxRect-rect");

                var o = s / d,
                    n = e.width - 40,
                    c = e.height,
                    h = n / c;
                o > h ? (i.videoWidth = n, i.videoHeight = n / o) : (i.videoHeight = c, i.videoWidth = c * o),
                    i.videoInfo.fpsRatio = i.videoInfo.fpsWidth / i.videoWidth;
                console.log(i.videoHeight, "this.videoHeight");
                console.log(i.videoWidth, "this.videoWidth");
                this.$nextTick(function () {
                    i.initVideoRect();
                    i.initTimeRect();

                });
            });
        },
        initVideoRect() {
            var e = this;
            this.$nextTick(() => {
                const t = document.querySelector(".video_sp").getBoundingClientRect();
                e.videoRect = t, 0 === e.videoRect.width && (e.videoRect.width = e.videoWidth),
                    0 === e.videoRect.height && (e.videoRect.height = e.videoHeight), console.log(
                        t,
                        "initVideoRect-rect");
                setTimeout(() => {
                    this.addSelectBox()
                    // this.minSelectBox.width = this.videoWidth * 0.1
                    this.minSelectBox.height = t * 0.1 > 10 ? 10 : t * 0.1
                    // this.maxSelectBox.width = this.videoWidth * 0.1
                    this.maxSelectBox.height = t * 0.5
                    this.play()
                }, 100);
            })

        },
        initTimeRect() {
            // var e = this;
            // this.$nextTick(() => {
            //     const t = document.querySelector(".deo_content").getBoundingClientRect();
            //     e.timeRect = t, console.log(t, "initTimeRect-rect");
            // })

        },
        onTimeUpdateEvent(t) {
            // console.log(t)
            var e = t.target,
                i = e.currentTime;
            e.duration;
            this.videoInfo.progress = 1e3 * t.target.currentTime;

        },
        onPlay() {
            this.videoLinkIsPlay = true;
        },
        onPause() {
            this.videoLinkIsPlay = false;
        },
        onEnded() {
            this.videoInfo.progress = this.videoInfo.duration
            // this.videoContext.currentTime=(this.videoInfo.duration /1e3)
            this.videoLinkIsPlay = !1
            console.log("onEnded");
        },
        videoErrorCallback(e) {
            console.log(e)
        },
        play() {
            this.videoContext.play()
            this.videoLinkIsPlay = !0;
        },
        pause() {
            this.videoContext.pause()
            this.videoLinkIsPlay = !1;
        },
        sliderChange(t) {
            console.log(t, "sliderChange - v")
            this.videoInfo.progress = t
            if (t === this.videoInfo.duration) {
                this.videoContext.currentTime = t / 1e3;
            }

            console.log(t / 1e3)
            // this.videoContext.seek(t / 1e3)
        },
        sliderChanging(t) {
            // console.log(t, "sliderChanging - v")
            if (this.videoInfo.progress !== t) {
                this.videoInfo.progress = t;
                this.videoContext.currentTime = t / 1e3;
            }
        },
        formatSeconds(value) {
            var secondTime = parseInt(value / 1000); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
                //获取分钟，除以60取整数，得到整数分钟 
                minuteTime = parseInt(secondTime / 60);
                //获取秒数，秒数取佘，得到整数秒数
                secondTime = parseInt(secondTime % 60);
                //如果分钟大于60，将分钟转换成小时
                if (minuteTime > 60) {
                    //获取小时，获取分钟除以60，得到整数小时
                    hourTime = parseInt(minuteTime / 60);
                    //获取小时后取佘的分，获取分钟除以60取佘的分
                    minuteTime = parseInt(minuteTime % 60);
                }
            }
            if (secondTime < 10) {
                var result = '0' + parseInt(secondTime);
            } else {
                var result = parseInt(secondTime);
            }


            if (minuteTime > 0) {
                result = "0" + parseInt(minuteTime) + ":" + result;
            } else {
                result = "00" + ":" + result;
            }
            // console.log(result)
            return result;
        },
        handleKeyup(event) {
            if (event.keyCode === 32 && this.videoContext) { // 检查 videoContext 是否存在
                this.videoLinkIsPlay ? this.pause() : this.play();
                return false; // 阻止默认的页面滚动行为
            }
        },
        createurl(url) {
            url = encodeURIComponent(url)
            this.originalUrl = decodeURIComponent(url)
            if (url.indexOf("kissxx") == -1 && url.indexOf("siyoa") == -1) {
                const loading = this.$loading(this.$loadinginfo);
                var data = {
                    url: url
                }
                this.$ajax.post('qhy/user/qsyjk', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    var jg = res.data
                    if (res.data.status == 200) {
                        url = jg.data.playAddr
                    } else {
                        this.$message.error(res.data.msg);
                    }
                    console.log(url)
                    this.videoUrl = decodeURIComponent(url)
                    this.videoContext = this.$refs.myVideo
                    loading.close();
                })
            } else {

                this.videoUrl = decodeURIComponent(url)
                this.videoContext = this.$refs.myVideo
            }
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // var url = 'https://video.kissxx.cn/jiaoxue/剧情剪辑.mp4'
        // var url = this.$route.query.url

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.addEventListener('keyup', this.handleKeyup);
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() {
        document.removeEventListener('keyup', this.handleKeyup);
    }, // 生命周期 - 销毁之前

    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
html {
    touch-action: manipulation;

}

html,
body {
    overscroll-behavior: none;

}

body {
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
}

.page {
    height: 100%;

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}

.yjcc_box {
    background-color: #151515;
    flex-direction: column;
    height: 100%;
    position: absolute;
}

.video_box,
.yjcc_box {
    display: flex;
    width: 100%;
}

.video_box {
    align-items: center;
    background-color: #1e1e1e;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: 0;
}

.move_box {
    position: absolute;
}

.move_box,
.move_box movable-area {
    height: 100%;
    width: 100%;
}

.movable-area {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.video_list {
    display: flex;
    position: relative;
}

.video_list image {
    height: 414px;
}

.video_sp {
    object-fit: contain;
}

.border_title {
    background-color: hsla(238, 60%, 63%, 0.6);
    border: 3px solid #3f53d1;
    box-sizing: border-box;
    color: #fff;
    font-size: 28rpx;
    height: 52px;
    width: 80px;
    z-index: 4;
    position: absolute;
}

.btn_move {
    bottom: -8px;
    position: absolute;
    right: -8px;
    height: 22px;
    width: 22px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    transform: rotate(-45deg);
    /* 添加旋转 */
}

.btn_fixed {
    bottom: -6px;
    left: -6px;
    position: absolute;
}

.btn_fixed div,
.btn_white div {
    background-color: #fff;
    border-radius: 50%;
    height: 20rpx;
    width: 20rpx;
    box-shadow: 0px 0px 10px #aaaaaa;
}

.btn_white {
    left: -6px;
    position: absolute;
    top: -6px;
}

.btn_move div {
    background-color: #f37786;
    border-radius: 50%;
    height: 32rpx;
    width: 32rpx;
    box-shadow: 0px 0px 10px #aaaaaa;
}

.btn_del {
    align-items: center;
    background-color: #000000;
    border-radius: 50%;
    flex-shrink: 0;
    height: 20px;
    width: 20px;
    justify-content: center;
    position: absolute;
    right: -8px;
    top: -8px;
    box-shadow: 0px 0px 5px #424242ff;
    font-size: 14px;
}

.btn_del,
.btn_del uni-icons {
    display: flex;
}

.task_footer {
    background-color: #151515;
    bottom: 0;
    /* padding-bottom: env(safe-area-inset-bottom); */
    /* position: sticky; */
    width: 100%;
}

.center_box {
    align-items: center;
    background-color: #1e1e1e;
    color: #c6c6c6;
    display: flex;
    flex-direction: row;
    font-size: 22rpx;
    justify-content: space-between;
    /* margin-bottom: 10px; */
    padding: 5px 24px 8px 24px;
}

.btn_bf uni-icons {
    padding: 0 30rpx;
}

.center_box div {
    width: 33.333%;
}

.center_box div:nth-child(2) {
    display: flex;
    justify-content: center;
}

.u-slider {
    margin: 0 6px;
}

.bottom_box {
    background-color: #151515;
}

.tip_text {
    color: #bbb;
    font-size: 20rpx;
    padding: 6px 0;
    text-align: center;
}

.video_content {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 100%;
}

.line_y {
    background-color: #fff;
    border-radius: 6px;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, .2));
    height: 60px;
    left: 50%;
    position: absolute;
    width: 4rpx;
    z-index: 1;
}

.scroll-div {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    /* 禁止内容换行 */
}

.video_img {
    background-color: #f6f7f8;
    border-radius: 4rpx;
    height: 42px;
    margin-left: 50%;
    margin-right: 50%;
    margin-top: 8rpx;
    width: 100%;
}

.user_Button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 14px 15px 25px;
}

.czq_content {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 104px;
    pointer-events: all;
}

.user_Button button {
    align-items: center;
    background-color: #5151f5;
    border: none;
    border-radius: 30px;
    display: flex;
    font-size: 30rpx;
    justify-content: center;
    line-height: 2.7;
    margin-left: 0;
    margin-right: 0;
    width: 47%;
}

button::after {
    border: none;
}

.btn_xt {
    background-color: #c8c8c8 !important;
    color: #080808 !important;
}

.deo_content {
    height: 104px;
    margin: 0 18px;
}

.line_box {
    height: 26px;
    margin: 10px 0 16px;
    width: 100%;
}

.active_dege {
    border: 1rpx solid #fff;
    border-radius: 6rpx 0 0 6rpx !important;
    position: relative;
    z-index: 3;
}

.active_dege .left_active_rear {
    align-items: center;
    background-color: #fff;
    border-bottom-left-radius: 8rpx;
    border-top-left-radius: 8rpx;
    display: flex;
    height: 28px;
    justify-content: center;
    left: -12px;
    position: absolute;
    top: -1px;
    width: 26rpx;
}

.active_dege .left_active_rear::after {
    background-color: #b1b1b1;
    border-radius: 5px;
    content: "";
    display: block;
    height: 12px;
    width: 2px;
}

.active_dege .right_active_rear {
    align-items: center;
    background-color: #fff;
    border-bottom-right-radius: 8rpx;
    border-top-right-radius: 8rpx;
    display: flex;
    height: 28px;
    justify-content: center;
    position: absolute;
    right: -12px;
    top: -1px;
    width: 26rpx;
}

.active_dege .right_active_rear::after {
    background-color: #b1b1b1;
    border-radius: 5px;
    content: "";
    display: block;
    height: 12px;
    width: 2px;
}

.thread_box {
    background-color: #5258c6;
    border-radius: 6rpx;
    height: 26px;
    width: 140rpx;
}

.pop-wrap {
    max-height: calc(120vh - 100px);
}

.bg_popup {
    background-color: initial;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;
}

.center_item {
    align-items: center;
    background: #fff;
    border-radius: 20rpx;
    color: #333;
    display: flex;
    flex-direction: column;
    left: 50%;
    padding: 44rpx 64rpx 36rpx;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 460rpx;
}

.title_item {
    font-size: 36rpx;
    font-weight: 500;
    padding: 6rpx 0;
}

.small_title {
    color: #ff8d1a;
}

.small_title,
.small_title_2 {
    font-size: 28rpx;
    padding: 10rpx 0;
    word-break: break-all;
}

.mp-img {
    text-align: center;
}

.mp-img image {
    flex-shrink: 0;
    height: 400rpx !important;
    width: 400rpx !important;
}

.content_item {
    height: 100%;
    position: relative;
    width: 100%;
}

.content_item .btn_box {
    bottom: 12%;
    left: 46%;
    position: absolute;
}

.icon_ljtb {
    height: 80rpx;
    margin: 8rpx 30rpx 14rpx;
    width: 80rpx;
}

.btn_box {
    width: 100%;
}

.btn_box .btn_confirm {
    margin: 24rpx 0 0;
}

.btn_confirm {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 30rpx 30rpx 0;
}

.text_red {
    color: #f52946;
    padding: 10rpx 0 !important;
}

.btn_confirm button {
    background-color: #fff;
    border: 1rpx solid #e5e5e5;
    border-radius: 30px;
    color: #333;
    font-size: 30rpx;
    line-height: 2.5;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    width: 47%;
}

.btn_qc {
    background-color: #505ed9 !important;
    border: 1rpx solid #505ed9 !important;
    color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Qzm.vue



// WEBPACK FOOTER //
// src/components/User/Qzm.vue